(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("immutable"));
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsLibUtil", ["immutable"], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsLibUtil"] = factory(require("immutable"));
	else
		root["DecapCmsLibUtil"] = factory(root["DecapCmsDefaultExports"]["Immutable"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__2522__) => {
return 